import { atom } from 'recoil';
import { Payment } from '../domain/payment';

export const PaymentState = atom<Array<Payment> | null>({
  key: 'PaymentState',
  default: null,
});
